import React from "react";
import { useNavigate } from "react-router-dom";

const sponsors = [
  { name: "AirGlow", logo: "/s5.png" },
  { name: "ADNOC", logo: "/s6.png" },
  { name: "Dolphin Energy", logo: "/s7.png" },
  { name: "Emirates NBD", logo: "/s8.png" }
];

const SponsorsSection = () => {
 
  const navigate = useNavigate();

  return (
    <div 
      style={{ backgroundImage: "url(/bgwhite.png)" }} 
      className="px-4 py-10 text-center bg-white sm:px-6 sm:py-12"
    >
      <h2 className="text-2xl font-semibold text-gray-800 sm:text-3xl">Gold</h2>
      <p className="font-medium text-gray-700 text-md sm:text-lg"> </p>

      <div className="grid max-w-5xl grid-cols-1 gap-4 mx-auto mt-6 sm:gap-6 sm:mt-8 sm:grid-cols-2 md:grid-cols-4">
        {sponsors.map((sponsor, index) => (
          <div 
            key={index} 
            className="flex items-center justify-center p-3 bg-white shadow-md sm:p-4 rounded-xl"
          >
            <img src={sponsor.logo} alt={sponsor.name} className="max-h-16 sm:max-h-20" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SponsorsSection;
